// extracted by mini-css-extract-plugin
export default {"container":"xnvWDkv9nySgV_UCOiEu","row":"M8H1z1DDlqAeNjgiYk5u","column":"V_V92bJn29l8W3OAMLFG","header":"sQJ1g8sY2PHTKvKYqdNE","arrowRight":"e_c1wSul0RPXBO8QFtEN"};